import { IMPROVE_CONFIG } from "@/config.js";
import axios from 'axios';
/*Deploy debug*/
export default {
  getClients: function(params, search, id = 0) {    
    if(id != 0) {
      return axios.get(IMPROVE_CONFIG.API_URL + "/clients" + params + search + "&id=" + id);
    } else {
      return axios.get(IMPROVE_CONFIG.API_URL + "/clients" + params + search);
    }
  },
  getClientsWithBasicDetails: function(params, search, id = 0) {    
    if(id != 0) {
      return axios.get(IMPROVE_CONFIG.API_URL + "/clients-baisc-details" + params + search + "&id=" + id);
    } else {
      return axios.get(IMPROVE_CONFIG.API_URL + "/clients-baisc-details" + params + search);
    }
  },
  getEnrolledUsers: function(params) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/clients" + params);
  },
  getUser: function(userId, params) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/users/" + userId + params);
  },
  enableDisableNotifications: function(userId, type) {
    return axios.put(IMPROVE_CONFIG.API_URL + "/user/update-notification/" + userId, {
      is_notification: type
    })
  },
  enableDisableEmail: function(type) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/company/update-mail-setting?include=thumbnail,company", {
      enable_mail: type
    })
  },
  sendWelcomeEmail: function(id) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/user/send-welcome-email/" + id)
  },
  getProfile: function(params) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/user/profile" + params);
  },
  getChannels: function(params) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/user/channels" + params);
  },
  getUserCourses: function(params, id = 0) {
    if(!id) {
      return axios.get(IMPROVE_CONFIG.API_URL + "/users/courses" + params);
    } else {
      return axios.get(IMPROVE_CONFIG.API_URL + "/users/courses" + params+ "&id=" + id);
    }
  },
  createUser: function(user) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/user", {
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      password: user.password,
      confirm_password: user.confirm_password,
      groups: user.groups,
      send_email: user.send_mail,
      site_id: user.site_id,
    });
  },
  updatePassword: function(user) {
    return axios.put(IMPROVE_CONFIG.API_URL + "/user/update-password", {
      old_password: user.old_password,
      new_password: user.new_password,
      confirm_password: user.confirm_password
    });
  },
  updateUser: function(id, user) {
    return axios.put(IMPROVE_CONFIG.API_URL + "/users/" + id, {
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      groups: user.groups,
      role_id: user.role_id,
      password: user.password,
      banding: user.banding,
      organization_name: user.organization_name,
      confirm_password: user.confirm_password,
      reset_email: user.is_mail_sent,
      assigned_users: [4, 7].includes(user.role_id) ? user.assigned_users : [],
      site_id: user.site_id,
    });
  },
  importUser: function(file) {
    let formData = new FormData();
    formData.append('file', file);
    return axios.post(IMPROVE_CONFIG.API_URL + "/user/import", formData, {
      // file: JSON.stringify(file),
      headers: {
        'content-type': 'multipart/form-data; boundary=${formData._boundary}',
      },
    });
  },
  createOwner: function(user, pid,s3, file) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/register", {
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      password: user.password,
      confirm_password: user.confirm_password,
      company_name: user.company_name,
      banding: typeof user.banding === 'object' && user.banding !== null ? user.banding.id : user.banding,
      partner_id:pid,
      product: user.product,
      senso_customer:user.senso_customers,
      is_company: user.is_company,
      customer_id: user.customer_id,
      s3_url: s3,
      company_logo: file,
      manager_id: user.manager_id,
      clone_option: user.clone_option,
      company_id: user.company_id,
      package: typeof user.package === 'object' && user.package !== null ? user.package.id : null,
      moduels: user.modules,
    });
  },
  updateOwner: function(id, user, s3, file) {
    return axios.put(IMPROVE_CONFIG.API_URL + "/users/" + id, {
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      role_id: user.role_id,
      password: user.password,
      confirm_password: user.confirm_password,
      company_name: user.company_name,
      banding: user.banding,
      type: "updateOwner",
      company_logo: file,
      s3_url: s3,
      manager_id: user.manager_id,
      theme_color: user.theme_color
    });
  },
  createManager: function(user, pid) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/manager", {
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      password: user.password,
      confirm_password: user.confirm_password,
      partner_id: pid,
      permission: user.permission
    });
  },
  updateManager: function(id, user) {
    return axios.put(IMPROVE_CONFIG.API_URL + "/managers/" + id, {
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      permission: user.permission,
      password: user.password,
      confirm_password: user.confirm_password
    });
  },
  getManagers: function(partnerId) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/managers/" + partnerId);
  },
  updateBreatheAPI: function(user) {
    return axios.put(IMPROVE_CONFIG.API_URL + "/user/update-breatheapi", {
      breathehr_api: user.breathehr_api
    });
  },
  removeBreatheAPI: function(user) {
    return axios.put(IMPROVE_CONFIG.API_URL + "/user/remove-breatheapi");
  },
  importBreatheHrUser: function() {
    return axios.put(IMPROVE_CONFIG.API_URL + "/user/import-breatheusers", {
      type: 'import-breatheusers'
    });
  },
  getUsersWithoutPagination: function(id) {    
    return axios.get(IMPROVE_CONFIG.API_URL + "/customer-user/" + id);
  },
  exportUserCSV: function(params, search, type) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/clients-export" + params + search + type);
  },
  updateOwnerProfile: function(id, user, s3, file) {
    return axios.put(IMPROVE_CONFIG.API_URL + "/users/" + id, {
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      s3_url: s3,
      company_avatar: file,
      updateProfile:'yes'
    });
  },
  archiveUser: function(userId) {
    return axios.put(IMPROVE_CONFIG.API_URL + "/archive-account/" + userId,{
        'is_archived':1
    });
  },
  getArchivedClients: function(params, search, id = 0) {    
    if(id != 0) {
      return axios.get(IMPROVE_CONFIG.API_URL + "/archived-clients" + params + search + "&id=" + id);
    } else {
      return axios.get(IMPROVE_CONFIG.API_URL + "/archived-clients" + params + search);
    }
  },
  getArchivedUserCourses: function(id, params,searchParams) {
    searchParams = (searchParams) ? searchParams : "";
    return axios.get(IMPROVE_CONFIG.API_URL + "/archived-user-courses/" + id + params + searchParams);
  },
  sendWelcomeEmailToUsers: function (selectedOption,userIds) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/user/send-mass-welcome-email", {
      send_mail_option: selectedOption,
      users: userIds,
    });
  },
  restoreUser: function(userId) {
    return axios.put(IMPROVE_CONFIG.API_URL + "/archive-account/" + userId,{
        'is_archived':0
    });
  },
  getAllUsers: function(params="", search="") {
    return axios.get(IMPROVE_CONFIG.API_URL + "/get-all-clients" + params + search);
  },
  getManagerUsers: function(id) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/get-manager-users/" + id);
  },
  getManagerTeams: function(params) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/get-manager-teams" + params);
  },
  archiveManager: function(managerId,archived) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/archive-account-manager/" +managerId,{
      'is_archived': archived
    });
  },
  importHrUsers: function(companyId,UserId) {
    return axios.post(IMPROVE_CONFIG.HRSYNC_URL + "/users/sync", {
      CompanyId: companyId,
      RequestedBy: UserId
    });
  },
  getResourceCategory: function(categoryName =''){
    if (categoryName != "") {
      return axios.get(
        IMPROVE_CONFIG.API_URL + "/resource/categories/" + categoryName
      );
    } else {
      return axios.get(IMPROVE_CONFIG.API_URL + "/resource/categories");
    }
  },
  getResources: function(categoryId){
    return axios.get(IMPROVE_CONFIG.API_URL + "/resources/"+categoryId);
  },
  getQuickResources: function(){
    return axios.get(IMPROVE_CONFIG.API_URL + "/quick-resources");
  },
  importCustomer: function(file) {
    let formData = new FormData();
    formData.append('file', file);
    return axios.post(IMPROVE_CONFIG.API_URL + "/customer_import", formData, {
      headers: {
        'content-type': 'multipart/form-data; boundary=${formData._boundary}',
      },
    });
  },
  emailMyTeamReport: function (){
        return axios.get(IMPROVE_CONFIG.API_URL + "/my-team-report");
  },
  releaseSeen: function (releaseId){
    return axios.post(IMPROVE_CONFIG.API_URL + "/releases/seen", {
      release_id: releaseId,
    });
  }
};
